import React from 'react'
import { Layout } from 'pcln-design-system'

export default function LayoutComponentWrapper({
  children
}: {
  children?: React.ReactNode | React.ReactNode[]
}) {
  return (
    <Layout variation="100" rowGap="xl">
      {children}
    </Layout>
  )
}
